<template>
  <v-container>
    <v-row justify-md="space-between">
      <v-col cols="12" md="auto">
        <v-btn @click="openFormDialog" class="accent shadow-4 px-8" color="success" large rounded>
          Añadir configuración
        </v-btn>
      </v-col>
    </v-row>

    <v-card class="shadow-1 mt-5">
      <v-data-table
        :search="search"
        :headers="headers"
        :items="whatsappConfigList"
        item-key="id"
        :loading="isLoading"
        :options.sync="options"
        :server-items-length="totalItems"
        :footer-props="{
          'items-per-page-options': [15, 30, 50, 100],
        }"
      >
        <template v-slot:[`item.start`]="{ item }">
          <span>{{ item.start | dateFormat }}</span>
        </template>

        <template v-slot:[`item.end`]="{ item }">
          <span>{{ item.end | dateFormat }}</span>
        </template>

        <template v-slot:[`item.action`]="{ item }">
          <!-- <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              icon
              :color="hover ? 'accent' : 'blue-grey'"
              @click.stop="handleShow(item.id)"
            >
              <v-icon>mdi-eye</v-icon>
            </v-btn>
          </v-hover> -->

          <v-hover v-slot:default="{ hover }">
            <v-btn text icon :color="hover ? 'accent' : 'blue-grey'" @click.stop="handleEdit(item)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </v-hover>

          <v-hover v-slot:default="{ hover }">
            <v-btn text icon :color="hover ? 'error' : 'blue-grey'" @click.stop="handleDelete(item.id)">
              <v-icon>mdi-trash-can-outline</v-icon>
            </v-btn>
          </v-hover>
        </template>
      </v-data-table>
    </v-card>

    <newForm
      v-if="isOpenForm"
      :isActive="isOpenForm"
      :dataToEdit="dataToEdit"
      :isEditMode="isEditMode"
      @close:dialog="closeFormDialog"
    ></newForm>
  </v-container>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";
// import newForm from "./newForm.vue";
import newForm from "@/views/app/clientSettings/whatsAppConfig/newForm.vue";

export default {
  components: {
    newForm,
  },

  data: () => ({
    isLoading: false,
    isOpenForm: false,
    isEditMode: false,
    surveyIDSelected: null,
    // For pagination
    totalItems: 0,
    options: {
      page: 1,
      itemsPerPage: 15,
    },
    // End for pagination
    whatsappConfigList: [],
    dataToEdit: {},
    search: "",
    headers: [
      {
        text: "Nombre",
        align: "left",
        value: "name",
        class: "primary--text",
        width: "20%",
      },
      {
        text: "URL WhatsApp",
        value: "url",
        class: "primary--text",
        width: "40%",
      },
      {
        text: "Estado",
        value: "status",
        class: "primary--text",
        width: "15%",
      },
      {
        text: "Mensaje cierre inactividad",
        align: "left",
        value: "closing_message",
        class: "primary--text",
        width: "15%",
      },
      {
        text: "Mensaje alerta inactividad",
        align: "left",
        value: "warning_message",
        class: "primary--text",
        width: "15%",
      },
      {
        text: "Acciones",
        value: "action",
        class: "primary--text",
        width: "15%",
        align: "left",
        sortable: false,
      },
    ],
  }),

  watch: {
    options: {
      handler() {
        this.getWhatsappConfig();
      },
      deep: true,
    },
  },

  created() {
    this.getWhatsappConfig();
  },

  methods: {
    openFormDialog() {
      this.isOpenForm = true;
    },

    closeFormDialog(payload) {
      this.isOpenForm = false;
      this.dataToEdit = {};

      if (payload) this.getWhatsappConfig();
    },

    handleEdit(item) {
      this.isEditMode = true;
      this.dataToEdit = item;
      this.openFormDialog();
    },

    // handleShow(SurveyId) {
    //   this.$router.push({
    //     name: "Detalles de formulario",
    //     params: { SurveyId },
    //   });
    // },

    // handleInfo(SurveyId) {
    //   this.$router.push({
    //     name: "Resultados formularios",
    //     params: { SurveyId },
    //   });
    // },

    async handleDelete(id) {
      try {
        const confirmRequest = await this.$swalconfirm(
          "Confirmar",
          `Está seguro de eliminar este evento? Ésta acción no es reversible.`,
        );
        if (confirmRequest.isConfirmed) {
          PbxHttpClient.delete(`/admin/config/whatsapps/${id}`)
            .then(() => {
              const index = this.whatsappConfigList.findIndex((el) => el.id === id);
              this.whatsappConfigList.splice(index, 1);

              this.$snotify.success("configuración eliminada", "¡Hecho!");
            })
            .catch(() => {
              // console.error(error);
              this.$snotify.error("Hubo un error al eliminar.", "Error");
            });
        }
      } catch (error) {
        this.$snotify.error("No se pudo eliminar la configuración.", "¡Error!");
        // console.error(error);
      }
    },

    // closeFormDialog(data = false) {
    //   if (data && this.isEditMode)
    //     this.whatsappConfigList = this.whatsappConfigList.map((el) =>
    //       el.id === data.id ? data : el
    //     );
    //   if (data && !this.isEditMode)
    //     this.whatsappConfigList = [...this.whatsappConfigList, data];
    //   this.isOpenForm = false;
    //   this.isEditMode = false;
    //   this.dataToEdit = {};
    // },

    async getWhatsappConfig() {
      this.isLoading = true;

      const { page, itemsPerPage } = this.options;

      await PbxHttpClient.get(`/admin/config/whatsapps/`, {
        params: { page, itemPerPage: itemsPerPage },
      })
        .then((res) => {
          this.whatsappConfigList = res.data.data;
          this.totalItems = res.data.total;
        })
        .catch(() => {
          // console.error(error);
          this.$snotify.error("Hubo un error en la consulta.", "Error");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
